module.exports = __webpack_public_path__ + "img/intratuin_cups.b62a046b.jpg";